module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addToCart":"Zum Warenkorb Hinzufügen"},"en":{"addToCart":"Add to Cart"}}')
  delete Component.options._Ctor
}
